module.exports = __webpack_public_path__ + "7d8911907d8806475ecb7354be6f3e7b.MP3";